<template>
  <profile class="softwareproducts" :options="options">
    <template #header>
      <div id="welcome_row">
        <div class="mainWrap mt-5">
          <div class="row">
            <div class="col-6 col-sm-6">
              <h1 class="h1-white">Publish your Apps here</h1>
            </div>
            <div id="trim_image" class="d-lg-block d-none col-6">
              <img
                class="me-2"
                src="@/assets/img/ui/plcnext_pfeile.svg"
                alt="PLCNext arrows logo"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <slot />
  </profile>
</template>

<script lang="ts" setup>
import Profile from "~/components/shared/layout/profile.vue";
import { useUserStore } from "~/stores/userstore";
import type { Component } from "vue";
import {
  PhCode,
  PhCertificate,
  PhFileCode,
  PhStorefront,
  PhCurrencyDollar,
} from "@phosphor-icons/vue";

const userStore = useUserStore();
const companyStore = useCompanyStore();

const options = computed(() => {
  let baseOptions: { name: string; link: string; icon: Component }[] = [];

  if (companyStore.userCompany?.approvedContributor) {
    baseOptions = [
      {
        name: "Software Products",
        link:
          "/users/" + userStore.authUserUuid + "/developer/software-products",
        icon: PhCode,
      },
      {
        name: "Certificates",
        link: "/users/" + userStore.authUserUuid + "/developer/certificates",
        icon: PhCertificate,
      },
    ];
  }

  if (userStore.isCompanyAdmin) {
    baseOptions.push({
      name: "Developer Profile",
      link: "/users/" + userStore.authUserUuid + "/developer/profile",
      icon: PhFileCode,
    });
  }

  if (
    userStore.isCompanyAdmin &&
    companyStore.userCompany?.approvedContributor
  ) {
    baseOptions.push(
      {
        name: "Store Profile",
        link: "/users/" + userStore.authUserUuid + "/developer/stores",
        icon: PhStorefront,
      },
      {
        name: "Credit Note Email",
        link: "/users/" + userStore.authUserUuid + "/developer/creditnoteemail",
        icon: PhCurrencyDollar,
      },
    );
  }

  return baseOptions;
});
</script>
<!-- does not work with scoped because the template is defined in profile.vue layout -->
<style lang="scss">
@use "@/sass/layouts/SoftwareProducts.scss" as *;
</style>
